exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-module-iconStyle{width:48px;height:48px;border-radius:50%;box-sizing:border-box;padding:10px}svg{width:18px}.icon-module-iconStyle_white{color:#fffefe;border:2px solid rgba(255,254,254,.2)}.icon-module-iconStyle_red{color:#992631;border:2px solid rgba(153,38,49,.1)}", ""]);

// Exports
exports.locals = {
	"iconStyle": "icon-module-iconStyle",
	"iconStyle_white": "icon-module-iconStyle_white icon-module-iconStyle",
	"iconStyle_red": "icon-module-iconStyle_red icon-module-iconStyle"
};